import CRUDServiceOperations from "./CRUDServiceOperations";

class UserService extends CRUDServiceOperations {
  getUserByParty(id, callback, failureCallback) {
    const url = this.urlFactory.userPartyIdUrl(id);
    return this.getEntitiesByUrl(url, callback, failureCallback);
  }

  getUsersBasic(urlAppender, pageInfo, sortInfo, callback, failureCallback) {
    const appender = urlAppender ? "/" + urlAppender : "";
    const url = this.getEntitiesUrl() + appender;
    return this.getEntitiesWithParams(
      url,
      pageInfo,
      sortInfo,
      callback,
      failureCallback
    );
  }

  getEntitiesUrl = () => {
    return this.urlFactory.usersUrl();
  };

  getPartyClassificationsByOperation(partyId, callback, failureCallback) {
    const url = this.urlFactory.partyClassificationsByOperation(partyId);
    return this.getEntitiesByUrl(url, callback, failureCallback);
  }
}

export default UserService;
